import React from 'react';
import { UiCheckbox, UiFormControlLabel, UiLabel } from 'ui-components/index';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toggleExportExcelField, toggleAllExportExcelFields } from 'store';

const ExportContentMoreSettings = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const page = useSelector((state) => state.excelExportReducer.page);
  const platform = useSelector((state) => state.excelExportReducer.platform);
  const excelFields = useSelector(
    (state) => state.excelExportReducer.excelFields
  );

  const toggleSwitch = (_key) => {
    dispatch(toggleExportExcelField(_key));
  };

  const areAllFieldsSelected = () => {
    return Object.values(excelFields[page][platform]).every(
      (field) => field.selected
    );
  };

  const toggleAllSwitch = () => {
    dispatch(toggleAllExportExcelFields(!areAllFieldsSelected()));
  };

  return (
    <div className='export-content-fields'>
      <div className='mb-16'>
        <UiLabel>{t('content:selectExcelExport')}</UiLabel>
      </div>
      <div>
        <UiFormControlLabel
          label={t('common:selectAll')}
          className='export-content-field mr-0'
          onChange={toggleAllSwitch}
          checked={areAllFieldsSelected()}
          control={<UiCheckbox />}
        ></UiFormControlLabel>
      </div>
      <div className='flex wrap'>
        {Object.values(excelFields[page][platform]).map((field) => (
          <UiFormControlLabel
            label={t(`excel:${field.title}`)}
            key={field.title}
            className='export-content-field mr-0'
            onChange={() => toggleSwitch(field.title)}
            checked={field.selected}
            control={<UiCheckbox />}
          ></UiFormControlLabel>
        ))}
      </div>
    </div>
  );
};

export default ExportContentMoreSettings;
